export const locales = {
	openCalendar: 'Ouvrir le calendrier'
};
